import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../store/slices/Billing/staffBillingSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  useGetGliListDataQuery,
  useUpdateBillingTableHeadDataMutation,
} from "../../../store/queries/Billing";
import { debounce } from "lodash";
import getFilterCount from "../../../utils/getFilterCount";

export const useStaffBilling = () => {
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];
  const [filterShow, setFilterShow] = useState(false);
  const billingState = useSelector((state) => state.staffBilling);
  const { showEditModal } = useSelector((state) => state.global);
  const [updateBillingTableHeadData] = useUpdateBillingTableHeadDataMutation();
  const dispatch = useDispatch();
  const {
    data: billingList = {},
    refetch,
    isLoading,
    isFetching,
  } = useGetGliListDataQuery({
    per_page: billingState?.currentPageSize,
    page: billingState?.currentPage,
    sort_by: billingState?.sortBy,
    sort_order: billingState?.sortOrder,
    start: billingState?.startDate,
    end: billingState?.endDate,
    search: billingState?.search,
    date: billingState.date ? billingState.date : [],
    item_type: billingState.item_type ? billingState.item_type : [],
    shop: billingState.shop ? billingState.shop : [],
    status: billingState.status ? billingState.status : [],
  });
  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
           gli_number: (field, data) => (
        <div className="pro-d-flex pro-flex-column pro-gap-1">
          
          <p className="pro-mb-0">{data[field]}</p>
     {data?.return_status === true && (
      <span className="outline-success pro-badge pro-d-inline-block w-max">
        Return Case
      </span>
    )}
        </div>
      ),

      service: (feild, data) => (
        <ul>
          {data[feild]?.map(({ name }, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
      work_status: (_, data) =>
        data?.work_status === "Rejected" ? (
          <span className={"pro-badge badge-danger-outline pro-d-inline-block"}>
            {"Rejected"}
          </span>
        ) : data?.work_status === "Marked" ? (
          <span className={"outline-primary pro-badge pro-d-inline-block"}>
            {"Marked"}
          </span>
        ) : data?.work_status === "Completed" ? (
          <span className={"outline-success pro-badge pro-d-inline-block"}>
            {"Completed"}
          </span>
        ) : data?.work_status === "Pending" ? (
          <span className={"outline-warning pro-badge pro-d-inline-block"}>
            {"Pending"}
          </span>
        ) : (
          <span className={"outline pro-badge pro-d-inline-block"}>
            {data?.work_status}
          </span>
        ),
      priority: (_, data) =>
        data?.priority === "Urgent" ? (
          <span className={"pro-badge badge-danger-outline pro-d-inline-block"}>
            {"Urgent"}
          </span>
        ) : data?.priority === "Normal" ? (
          <span className={"outline-primary pro-badge pro-d-inline-block"}>
            {"Normal"}
          </span>
        ) : data?.priority === "Hold" ? (
          <span className={"outline-warning pro-badge pro-d-inline-block"}>
            {"Hold"}
          </span>
        ) : (
          <span className={"outline pro-badge pro-d-inline-block"}>
            {data?.priority}
          </span>
        ),
    };

    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleSearchDebounced = debounce((value, dispatch) => {
    dispatch(
      updateConfig((state) => {
        state.search = value;
        state.currentPage = 1;
      })
    );
  }, 1000);

  const handleSearch = (e) => {
    handleSearchDebounced(e.target.value, dispatch);
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleSort = (label) => {
    if (billingState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = billingState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };
  const handleGenerateEstimate = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showAddBillingModal = !state.showAddBillingModal;
        state.selectedBilling = e;
      })
    );
  };

  const filterCount = useMemo(() => {
    return getFilterCount({
      from_date: billingState.from_date,
      to_date: billingState.to_date,
      item_type: billingState.item_type,
      shop: billingState.shop,
      status: billingState.status,
    });
  }, [billingState.from_date, billingState.to_date, billingState.item_type, billingState.shop, billingState.status]);

  return {
    isLoading,
    isFetching,
    filterShow,
    filterCount,
    billingState,
    billingList,
    showEditModal,
    paginationOptions,
    getRow,
    refetch,
    handleSort,
    handleSearch,
    setFilterShow,
    handlePageSize,
    handlePagination,
    handleGenerateEstimate,
    handleEditColumnsClick,
    updateBillingTableHeadData,
  };
};

export default useStaffBilling;
